import { MPARTICLE_LOG_MESSAGE_TYPE } from '../lib/constants';

const sensitiveKeys = ['currentSession'];

const sanitizeData = (data) => {
  const sanitized = { ...data };
  sensitiveKeys.forEach((key) => {
    if (sanitized[key]) {
      sanitized[key] = '**REDACTED**';
    }
  });
  return sanitized;
};

/**
 * @param type string - defines what type of event is being sent (AUTH_FAILURE, MPARTICLE_LOG, NAVIGATE)
 * @param config: optional string - defines which platform is being used (reactNative or react for web)
 * @param title: string - mParticle specific for analytics
 * @param data: obj - standard {key: value}
 */
const fireMessageEvent = ({ type, platform, env, title = '', data = {} }) => {
  const msgType = type || MPARTICLE_LOG_MESSAGE_TYPE;

  const sanitizedData = sanitizeData(data);
  const sentData = {
    type: msgType,
    evtSource: title,
    mParticleEvtType: 8,
    evtMessage: sanitizedData,
  };

  switch (platform) {
    case 'mobile':
      // to also send all existing logs to datadog
      if (type !== 'LOG' && type !== 'ERROR') {
        const sentDataForDataDog = {
          type: 'LOG',
          evtSource: 'hockey-challenge: ' + title,
          evtMessage: sanitizedData,
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(sentDataForDataDog));
      }
      window.ReactNativeWebView.postMessage(JSON.stringify(sentData));
      break;
    default:
      window.parent.postMessage(JSON.stringify(sentData), '*');
      break;
  }
  // example of mParticle reporting data format
  /**
    {
      type: 'MPARTICLE_LOG',
      evtSource: '[TH] T4G Tab Clicked',
      mParticleEvtType: 8,
      evtMessage: {
        tabName: content[tabIndex].eventKey,
      },
    }
   */
};

export { fireMessageEvent, sanitizeData };
